
import UriEncoding from '../encoding/UriEncoding';

export { deepCopy } from '@ms/utilities-objects/lib/deepCopy';
export { deepCompare } from '@ms/utilities-objects/lib/deepCompare';
export { safeSerialize } from '@ms/utilities-objects/lib/safeSerialize';
export { assign as extend } from '@ms/utilities-objects/lib/assign';

export const DEFAULT_DELIMITER = '&';
export const KEYVALUE_DELIMITER = '=';

/**
 * Serializes the object Name Values Pairs (Depth of 1).
 * Used for Query Strings and Cookie Values
 * @param {any} obj Object with name value pairs
 * @param {string} delimeter  Delimiter seperates the pairs
 * @param {boolean} skipEncoding True to skip encoding
 */
export function serialize(obj: any, delimiter?: string, skipEncoding?: boolean) {
    delimiter = delimiter || DEFAULT_DELIMITER;

    const values: string[] = Object.keys(obj).map((name: string) => {
        // Get the value and convert it to a string
        let value: string = obj[name];
        value = value ? value.toString() : "";

        if (!skipEncoding) {
            value = UriEncoding.encodeURIComponent(value);
        }

        // Add the encoded value to the array
        return name + KEYVALUE_DELIMITER + value;
    });

    return values.join(delimiter);
}
